import { useState, useCallback } from "react";

export interface ClipboardItem<T = any> {
    data: T[];
    type: "copy" | "cut" | null;
    metadata?: Record<string, any>;
}

export const useClipboard = <T = any>(initialState?: ClipboardItem<T>) => {
    const [clipboard, setClipboard] = useState<ClipboardItem<T>>(
        initialState || { data: [], type: null }
    );

    const copyToClipboard = useCallback((items: T[], metadata?: Record<string, any>) => {
        setClipboard({ data: items, type: "copy", metadata });
    }, []);

    const cutToClipboard = useCallback((items: T[], metadata?: Record<string, any>) => {
        setClipboard({ data: items, type: "cut", metadata });
    }, []);

    const clearClipboard = useCallback(() => {
        setClipboard({ data: [], type: null });
    }, []);

    const hasItems = clipboard.data.length > 0;
    const isCopy = clipboard.type === "copy";
    const isCut = clipboard.type === "cut";

    return {
        clipboard,
        copyToClipboard,
        cutToClipboard,
        clearClipboard,
        hasItems,
        isCopy,
        isCut
    };
};